import axios from 'api/afripods-http/axios-config'

const afripodsHttp = () => ({
  createTrackingData: (body) => axios.post('/data', body),
  createListOfTrackingData: (body) => axios.post('/data/list', body),
})

export default afripodsHttp()



// WEBPACK FOOTER //
// ./src/api/statistics/statistics.js